import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-dynamicTypeShape",
  "use": "svg-icon-dynamicTypeShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-dynamicTypeShape\"><g fill-rule=\"evenodd\"><path d=\"M2 1v6l2-.857V1zm0 14h2V9.857L2 9zM12 1v5.143L14 7V1zm0 8.857V15h2V9z\" /><path d=\"M10 3h4.001V.999H10zM2 3h4.001V.999H2zm8 12h4.001v-2H10zm-8 0h4.001v-2H2zM0 7v2l4-2.4v-2zm12-.4L16 9V7l-4-2.4z\" /><path d=\"M12 9.4v2L16 9V7zM0 9l4 2.4v-2L0 7z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol